/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Saluation from './saluation';
import SaluationDetail from './saluation-detail';
import SaluationUpdate from './saluation-update';
import SaluationDeleteDialog from './saluation-delete-dialog';

const SaluationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Saluation />} />
    <Route path="new" element={<SaluationUpdate />} />
    <Route path=":id">
      <Route index element={<SaluationDetail />} />
      <Route path="edit" element={<SaluationUpdate />} />
      <Route path="delete" element={<SaluationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SaluationRoutes;
